
import { alchemy } from "src/apis/alchemyToken";

async function fetchAlchemyToken(contractAddress: string, tokenId: string) {
    try {
        const res = await alchemy.nft.getNftMetadata(contractAddress, tokenId);
        return res.media[0]?.raw;
    } catch (error) {
        console.log(error);
    }
}

export default fetchAlchemyToken;